export default "__VITE_ASSET__Bk7evwI6__"